import { access } from '@driftt/traffic-control'

export const isFreeUser = () => (
  !['premium_enterprise', 'premium_team'].some(access.hasGates)
)
